export { renderCheckbox_unstable as renderCheckbox } from '@fluentui/react-checkbox';
